import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const updateAnnotationsEndpoint = async (data, id) => {
  const endpoint = API_ENDPOINTS.UPDATE_ANNOTATIONS(id);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating annotations: ${error.message}`);
  }
};

export const createAnnotationsEndpoint = async (dataArray, instanceId) => {
  const endpoint = API_ENDPOINTS.CREATE_ANNOTATIONS();
  const payload = {
    instance_id: instanceId,
    annotations: dataArray,
  };
  try {
    const response = await apiClient.post(endpoint, payload);
    return response;
  } catch (error) {
    throw new Error(`Error creating annotations: ${error.message}`);
  }
};

export const deleteAnnotationEndpoint = async id => {
  const endpoint = API_ENDPOINTS.DELETE_ANNOTATION(id);
  try {
    const response = await apiClient.delete(endpoint);
    return response;
  } catch (error) {
    throw new Error(`Error deleting annotation: ${error.message}`);
  }
};

export const deleteAnnotationsEndpoint = async (instanceId, payload) => {
  const endpoint = API_ENDPOINTS.DELETE_ANNOTATIONS(instanceId);
  try {
    return await apiClient.delete(endpoint, { data: payload });
  } catch (error) {
    throw new Error(`Error deleting annotations: ${error.message}`);
  }
};

export const sanityCheckAnnotationsEndpoint = async annotations => {
  const endpoint = API_ENDPOINTS.SANITY_CHECK_ANNOTATIONS();
  try {
    const response = await apiClient.post(endpoint, { annotations });
    return response.data;
  } catch (error) {
    throw new Error(`Error checking annotations: ${error.message}`);
  }
};
